import React, { useEffect, useState } from 'react';
import classes from "./TermsModal.module.css";
import { FaXmark } from "react-icons/fa6";
import { useSelector } from 'react-redux';

import termsEnglish from "../locales/policies/terms.english.json";
import termsFrench from "../locales/policies/terms.french.json";

const languageMap = new Map([
    ["0", termsEnglish],
    ["1", termsFrench],
]);


const TermsModal = ({ setTermsModal }) => {
    const { selectedLanguage } = useSelector(state => state.languageSlice);
   // const [terms, setTerms] = useState(null);

    useEffect(() => {
      //  const mapped = languageMap.get(selectedLanguage) || languageMap.get("0");
       // setTerms(mapped);
        console.log(selectedLanguage);
    }, [selectedLanguage]);

    //if (!terms) return null;

    return (
        <div className={classes.container} onClick={() => setTermsModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.close_btn_container}>
                    <button type="button" className={classes.close_btn} onClick={() => setTermsModal(false)}>
                        <FaXmark className={classes.close_icon} />
                    </button>
                </div>
                {selectedLanguage == 1?
                <div className={classes.msg}>
                    <p><strong>UVFOOTBALL XI &ndash; Confidentialit&eacute; Suppl&eacute;mentaire</strong></p><br/>
                    <p>Ce document de confidentialit&eacute; suppl&eacute;mentaire fournit des informations g&eacute;n&eacute;rales concernant le traitement effectu&eacute; pour le service UV Football XI, afin d'apporter un contexte suppl&eacute;mentaire &agrave; notre politique de confidentialit&eacute; principale. Si vous utilisez UV Football XI en combinaison avec un autre service, nous vous recommandons &eacute;galement de lire les informations relatives &agrave; la confidentialit&eacute; de ce dernier.</p>
                    <p>Pour toute question concernant cet aspect de la confidentialit&eacute;, veuillez contacter le service client d'Orange. Un membre de notre &eacute;quipe d&eacute;di&eacute;e vous r&eacute;pondra.</p>
                    <br/><p><strong>Pr&eacute;sentation de UV Football XI</strong></p>
                    <p>Rejoignez UV Football XI, la plateforme de fantasy football qui vous permet de constituer votre &eacute;quipe de r&ecirc;ve, de d&eacute;fier d'autres passionn&eacute;s et de tenter de gagner gros ! La victoire est &agrave; port&eacute;e de main. Les 5 meilleurs joueurs du classement auront la chance de tenter de remporter jusqu&rsquo;&agrave; 25 000 F CFA chaque mois.</p>
                    <br/><p><strong>Options d&rsquo;abonnement</strong></p>
                    <ul>
                    <li><strong>Abonnement avec renouvellement automatique</strong> : 50 CFA par jour ou 250 CFA par semaine.</li>
                    <li><strong>Achat unique</strong> : 60 CFA par jour ou 300 CFA par semaine.</li>
                    </ul>
                    <p><strong>Informations personnelles que nous recueillons</strong></p>
                    <p><strong>Types d&rsquo;informations collect&eacute;es</strong></p>
                    <ul>
                    <li>Votre nom et votre num&eacute;ro de t&eacute;l&eacute;phone portable</li>
                    <li>Votre type d&rsquo;abonnement et le canal de paiement (par exemple, cr&eacute;dit airtime)</li>
                    <li>Informations li&eacute;es &agrave; votre contact avec notre service client</li>
                    <li>Donn&eacute;es sur votre utilisation de l&rsquo;application (fr&eacute;quence d&rsquo;utilisation, heure de fermeture, alertes)</li>
                    <li>Donn&eacute;es sur votre utilisation de nos produits et services, telles que :</li>
                    <ul>
                    <li>Le niveau de service re&ccedil;u (rapports de livraison, retards, pannes, &eacute;v&eacute;nements impactant nos services)</li>
                    </ul>
                    </ul>
                    <p><strong>Moment de la collecte</strong></p>
                    <p>Nous recueillons vos informations personnelles lorsque :</p>
                    <ul>
                    <li>Vous vous abonnez au service</li>
                    <li>Vous utilisez les fonctionnalit&eacute;s de UV Football XI</li>
                    <li>Vous contactez notre service client pour toute question</li>
                    </ul>
                    <br/><p><strong>Utilisation de vos informations personnelles</strong></p>
                    <p><strong>Pour vous fournir le service</strong></p>
                    <p>Nous utilisons vos donn&eacute;es pour :</p>
                    <ul>
                    <li>Vous identifier</li>
                    <li>Vous donner acc&egrave;s au service</li>
                    <li>Assurer la facturation et le support client</li>
                    <li>Vous informer des changements pouvant vous affecter</li>
                    <li>V&eacute;rifier votre identit&eacute;</li>
                    </ul>
                    <br/><p><strong>Marketing et profilage</strong></p>
                    <p>Si vous avez accept&eacute; de recevoir des communications marketing et que vous nous avez autoris&eacute;s &agrave; utiliser vos donn&eacute;es pour personnaliser nos offres, nous analyserons vos interactions pour d&eacute;terminer le type de messages &agrave; vous envoyer.</p>
                    <br/><p><strong>Pour vous d&eacute;sinscrire des messages marketing ou du profilage :</strong></p>
                    <ul>
                    <li>Vous pouvez choisir de vous d&eacute;sabonner via les m&eacute;thodes suivantes :</li>
                    <ul>
                    <li>Contacter le service client d&rsquo;Orange au 8900</li>
                    <li>Cliquer sur le lien de d&eacute;sabonnement dans nos messages</li>
                    <li>Informer le conseiller lors d&rsquo;un appel de prospection</li>
                    <li>D&eacute;sactiver cette option dans les param&egrave;tres de votre application</li>
                    </ul>
                    </ul>
                    <p>La d&eacute;sinscription ne vous emp&ecirc;chera pas de recevoir des messages li&eacute;s au service, tels que ceux concernant votre commande ou les modifications de nos conditions g&eacute;n&eacute;rales.</p>
                </div>
                :<div className={classes.msg}>
                    <p><strong>UVFOOTBALL XI &ndash; Privacy Supplement</strong></p><br/>
                    <p>This privacy supplement provides additional information about the processing conducted for the UV Football XI product, to give further context to our main privacy policy. If you are using UV Football XI alongside another service, please review the privacy information for that service as well.</p>
                    <p>For any questions regarding this privacy supplement, please contact Orange Customer Care, and a dedicated team member will assist you.</p>
                    <br/><p><strong>About UV Football XI</strong></p><br/>
                    <p>"Join UV Football XI, the exciting fantasy football platform where you can build your dream team, challenge other passionate players, and try to win big! The top 5 players on the leaderboard will have the chance to win up to 25,000 F CFA each month."</p>
                    <br/><p><strong>Subscription options</strong></p>
                    <ul>
                    <li><strong>Auto-renewal subscription</strong>: 50 CFA daily or 250 CFA weekly.</li>
                    <li><strong>One-time purchase</strong>: 60 CFA daily or 300 CFA weekly.</li>
                    </ul>
                    <p><strong>Personal information we collect</strong></p>
                    <ul>
                    <li>Your name and mobile number</li>
                    <li>Subscription type and payment channel (e.g., airtime)</li>
                    <li>Customer care interactions</li>
                    <li>Usage data (frequency, alerts, etc.)</li>
                    <li>Service quality data (delivery reports, delays, faults, etc.)</li>
                    </ul>
                    <p><strong>When we collect your personal data</strong></p>
                    <ul>
                    <li>When you subscribe to the service</li>
                    <li>When you use UV Football XI features</li>
                    <li>When you contact customer support</li>
                    </ul>
                    <p><strong>How we use your personal data</strong></p>
                    <ul>
                    <li>To provide the service</li>
                    <li>To identify you and grant access</li>
                    <li>For billing and customer support</li>
                    <li>To notify you of service changes</li>
                    <li>For identity verification</li>
                    </ul>
                    <p><strong>Marketing and profiling</strong></p>
                    <p>If you have opted in and given permission, we may use your interactions to personalize marketing messages. To opt out:</p>
                    <ul>
                    <li>Contact Orange customer care at 8900</li>
                    <li>Use the unsubscribe link in our messages</li>
                    <li>Inform the adviser during outbound calls</li>
                    <li>Turn off notifications in your app settings</li>
                    </ul>
                    <p>Opting out of marketing communications does not affect service-related messages, which you will continue to receive unless otherwise specified.</p>
                </div>
        }
            </div>
        </div>
    );
};

export default TermsModal;